import { AspectRatioContainer, Container, Image } from '@volkswagen-onehub/components-core';
import React from 'react';
import { VehicleEtiquetas } from './vehicle-etiquetas';
import { VehicleImageContainer } from './vehicle-selected-styles';

interface SelectedVehicleImageProps {
	etiquetas?: string[];
	displayImage: string;
	alt: string;
	onError?: () => void;
}

export const VehicleImage = (props: SelectedVehicleImageProps) => {
	const { etiquetas, displayImage, alt, onError = () => {} } = props;
	return (
		<VehicleImageContainer data-testid="vehicle-image-container-desktop">
			<VehicleEtiquetas etiquetas={etiquetas} />
			<Image src={displayImage} alt={alt} onError={onError} />
		</VehicleImageContainer>
	);
};

export const VehicleImageMobile = (props: SelectedVehicleImageProps) => {
	const { etiquetas, displayImage, alt, onError } = props;
	return (
		<Container
			horizontalAlign={'center'}
			verticalAlign={'center'}
			wrap={'always'}
			data-testid="vehicle-image-container-mobile"
		>
			<VehicleEtiquetas etiquetas={etiquetas} />
			<AspectRatioContainer ratio={'16:9'}>
				<Image src={displayImage} alt={alt} onError={onError} />
			</AspectRatioContainer>
		</Container>
	);
};
